module.exports = __webpack_public_path__ + "img/food_drink.63db41d8.png";